import {AfterViewInit, Component, Inject, ViewChild, OnDestroy, OnInit} from '@angular/core';
import {NgForm} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Subscription} from 'rxjs';
import {Message} from '../../../core/class/message';
import {ToastrService} from 'ngx-toastr';
import {DocumentService} from '../../../core/services/document.service';
import {NotificationService} from '../../../core/services/notification.service';
import {WarningComponent} from '../../../shared/components/warning/warning.component';
import {AnonymousSignService} from '../../../core/services/anonymous-sign.service';
import { ErrorCode } from 'src/app/core/constants/error-code';

@Component({
  selector: 'app-anonymous-decline-sign-document',
  templateUrl: './anonymous-decline-sign-document.component.html',
  styleUrls: ['./anonymous-decline-sign-document.component.scss']
})
export class AnonymousDeclineSignDocumentComponent implements OnInit, AfterViewInit, OnDestroy {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private message: Message,
    private toastr: ToastrService,
    private documentService: DocumentService,
    public dialogRef: MatDialogRef<AnonymousDeclineSignDocumentComponent>,
    public notificationService: NotificationService,
    private anonymousSignService: AnonymousSignService,
  ) {
    this.document = data.document;
    this.hashKey = this.data.hashKey;
    this.tenantId = this.data.tenantId;
    this.hashLink = this.data.hashLink ? this.data.hashLink : null;
  }

  private hashKey: string;
  private tenantId: string;
  private hashLink: string = null;
  document = {
    id: 0,
    reason: '',
    hashKey: '',
    tenantId: ''
  };
  formChangesSubscription: Subscription;

  @ViewChild('f', {static: false}) ngForm: NgForm;
  public isFormChanging: boolean;
  private success: boolean;

  ngAfterViewInit() {
    this.formChangesSubscription = this.ngForm.form.valueChanges.subscribe(() => {
      if (this.ngForm.dirty) {
        this.isFormChanging = true;
      }
    });

    this.notificationService.subscribeErrorService();

    // Focus on textarea reason after load
    // There's a problem if not setTimeout it will focus on 'reason' then lost focus right after
    setTimeout(_ => document.getElementById('reason').focus(), 500);
  }

  ngOnInit(): void {
    this.notificationService.getErrorCode().subscribe(err => {
        if (err === '0x001719') {
          this.dialogRef.close(false);
        }
      });
  }

  ngOnDestroy(): void {
    this.notificationService.unsubscribeErrorService();
  }

  cancel() {
    if (this.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: 'messages.confirm_change_data'
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.dialogRef.close();
        }
        dialogRe.close();
      });
    } else {
      this.dialogRef.close();
    }
  }

  declineSignDocument() {
    this.anonymousSignService.declineSignDocument({
      ...this.document,
      hashKey: this.hashKey,
      tenantId: this.tenantId,
      hashLink: this.hashLink
    }).subscribe(rs => {
      this.success = true;
      this.checkDisplayMessageError(rs.code);
    });
  }
  checkDisplayMessageError(code) {
    if (code && code === ErrorCode.NoAccessToContracts) {
      if (this.dialogRef) {
        this.dialogRef.close(ErrorCode.NoAccessToContracts);
      }
    } 
    else if (code && code === ErrorCode.ContractExpireTime) {
      if (this.dialogRef) {
        this.dialogRef.close(ErrorCode.ContractExpireTime);
      }
    }
    else {
      this.toastr.success(this.message.getMessage('messages.refuse_sign_success'));
      this.dialogRef.close(this.success);
    }
  }

}

